(function () {
  'use strict';

  var SHORTS_SIZES = ['S', 'M', 'L', 'XL', 'XXL'];
  var SHORTS_ROWS = [
    ['Inseam', '5', '5', '5¼', '5½', '5¾'],
    ['Waist', '27', '29', '31', '33', '35']
  ];
  var BOTTOMS_SIZES = ['XS', 'S', 'M', 'L', 'XL'];
  var BOTTOMS_ROWS = [
    ['Waist', '28', '31', '33', '35', '37'],
    ['Inseam', '26', '27', '28', '29', '30']
  ];
  var OUTERWEAR_SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
  var OUTERWEAR_ROWS = [
    ['Length', '24', '25', '26', '27', '27.5', '28.5'],
    ['Chest', '48', '50', '52', '54', '56', '58'],
    ['Sleeve', '25', '25.5', '26', '27', '27.5', '28.5']
  ];
  var CUT_OFF_HOODIE_ROWS = [
    ['Length', '24', '25', '26', '27', '27.5', '28.5'],
    ['Chest', '48', '50', '52', '54', '56', '58']
  ];
  var PREMIUM_BEATER_SIZES = ['S', 'M', 'L', 'XL', 'XXL'];
  var PREMIUM_BEATER_ROWS = [
    ['Length', '27', '28', '29', '30', '31'],
    ['Chest', '37', '39', '41', '43', '45']
  ];
  var PUMP_SIZES = ['S', 'M', 'L', 'XL', 'XXL'];
  var PUMP_ROWS = [
    ['Length', '28.5', '29.1', '29.7', '30.3', '31.2'],
    ['Chest', '44', '46', '48', '50', '52']
  ];

  var CHARTS = {
    'apex-cut-off-hoodie': chart('IN', OUTERWEAR_SIZES, CUT_OFF_HOODIE_ROWS, 'Uses the Berserk outerwear measurements with the sleeve row omitted.'),
    'athletic-cargo-shorts': chart('IN', SHORTS_SIZES, SHORTS_ROWS, 'ASPYR shorts measurements.'),
    'berserk-cut-off': chart('IN', ['S', 'M', 'L', 'XL', 'XXL'], [
      ['Front body length', '25¼', '26', '26¾', '27½', '28¼'],
      ['Chest width', '23', '24', '25', '26', '27'],
      ['Shoulder width', '20¾', '21¾', '22¾', '23¾', '24¾'],
      ['Armhole straight', '10⅛', '10½', '10⅞', '11¼', '11⅝'],
      ['Bottom opening', '21½', '22½', '23½', '24½', '25½']
    ], 'Supplier-provided measurements.'),
    'berserk-zip-up': chart('IN', OUTERWEAR_SIZES, OUTERWEAR_ROWS, 'ASPYR outerwear measurements.'),
    'cerberus-cargo-sweats': chart('IN', BOTTOMS_SIZES, BOTTOMS_ROWS, 'ASPYR bottoms measurements.'),
    'compression-liner-dark-crimson': chart('IN', SHORTS_SIZES, SHORTS_ROWS, 'ASPYR shorts measurements.'),
    'esntl-athletic-cargos': chart('CM', ['M'], [
      ['Front length incl. waist', '101'],
      ['Front rise', '30'],
      ['Back rise', '40'],
      ['½ waist', '46'],
      ['½ leg opening', '25'],
      ['Inseam', '72'],
      ['Waist height', '5'],
      ['Flap', '19'],
      ['Front pocket length', '19'],
      ['Side pocket width', '22'],
      ['Side pocket height', '21'],
      ['Back pocket width', '18'],
      ['Back pocket height', '19']
    ], 'Only Medium was populated on the supplier sheet; remaining grading is pending.'),
    'esntl-cargo-sweat-shorts': chart('IN', SHORTS_SIZES, SHORTS_ROWS, 'Shared ASPYR shorts measurements.'),
    'esntl-joggers-gray': chart('IN', BOTTOMS_SIZES, BOTTOMS_ROWS, 'ASPYR bottoms measurements.'),
    'esntl-sweat-shorts-black': chart('IN', SHORTS_SIZES, SHORTS_ROWS, 'ASPYR shorts measurements.'),
    'fallen-pump-cover': chart('IN', PUMP_SIZES, PUMP_ROWS, 'ASPYR oversized shirt measurements.'),
    'fractured-mesh-shorts': chart('IN', SHORTS_SIZES, SHORTS_ROWS, 'ASPYR shorts measurements.'),
    'olympian-pump-cover': chart('IN', PUMP_SIZES, PUMP_ROWS, 'ASPYR oversized shirt measurements.'),
    'premium-beater-monochrome-3-pack': chart('IN', PREMIUM_BEATER_SIZES, PREMIUM_BEATER_ROWS, 'Shared Premium Beater measurements for every color, pack, preorder, and starter version.'),
    'relentless-pump-cover': chart('IN', PUMP_SIZES, PUMP_ROWS, 'ASPYR oversized shirt measurements.'),
    'relentless-zip-up': chart('CM', ['XS', 'S', 'M', 'L', 'XL', 'XXL'], [
      ['Neck width', '22.5', '23', '23.5', '24', '24.5', '25'],
      ['Shoulder to shoulder', '59.5', '61.5', '63.5', '65.5', '67.5', '69.5'],
      ['Front neck drop', '7.7', '8', '8.3', '8.6', '8.9', '9.2'],
      ['Front chest width', '52', '54', '56', '58', '60', '62'],
      ['Back width', '54.5', '56.5', '58.5', '60.5', '62.5', '64.5'],
      ['Armhole straight', '28', '29', '30', '31', '32', '33'],
      ['Chest', '124', '129', '134', '139', '144', '149'],
      ['Bottom opening', '90', '95', '100', '105', '110', '115'],
      ['Sleeve length', '—', '56', '57', '58', '59', '60'],
      ['Total length', '64', '66', '68', '70', '72', '74'],
      ['Hood length', '34', '34.5', '35', '35.5', '36', '36.5'],
      ['Hood width', '28.3', '29', '29.7', '30.4', '31.1', '31.8']
    ], 'Supplier-provided measurements. XS sleeve length is awaiting confirmation.'),
    'revenant-hoodie': chart('CM', ['S', 'M', 'L', 'XL', 'XXL'], [
      ['Neck width', '22.4', '23', '23.6', '24.2', '24.8'],
      ['Shoulder to shoulder', '78', '80', '82', '84', '86'],
      ['Armhole straight', '27', '28', '29', '30', '31'],
      ['Chest below armhole', '70', '72', '74', '76', '78'],
      ['Bottom opening', '45', '47', '49', '51', '53'],
      ['Sleeve length', '55.5', '57', '58.5', '60', '61.5'],
      ['Total length', '72.5', '74.5', '76.5', '78.5', '80.5'],
      ['Hood length', '41.5', '42', '42.5', '43', '43.5'],
      ['Hood width', '27.25', '28', '28.75', '29.5', '30.25']
    ], 'Supplier-provided measurements. XS values were not supplied.'),
    'revenant-sweatpants': chart('IN', ['S', 'M', 'L', 'XL', 'XXL'], [
      ['½ waist', '13', '14', '15', '16', '17'],
      ['Inseam length', '27⅞', '28½', '29⅛', '29¾', '30⅜'],
      ['½ hip', '21½', '22½', '23½', '24½', '25½'],
      ['Front rise incl. waist', '13⅝', '14', '14⅜', '14¾', '15⅛'],
      ['Back rise incl. waist', '16⅛', '16½', '16⅞', '17¼', '17⅝']
    ], 'Supplier-provided measurements. XS values were not supplied.'),
    'resurgence-cut-off-hoodie': chart('IN', OUTERWEAR_SIZES, CUT_OFF_HOODIE_ROWS, 'Uses the Berserk outerwear measurements with the sleeve row omitted.'),
    'thorn-cut-mesh-shorts': chart('IN', SHORTS_SIZES, SHORTS_ROWS, 'ASPYR shorts measurements.'),
    'unleashed-pump-cover': chart('IN', PUMP_SIZES, PUMP_ROWS, 'ASPYR oversized shirt measurements.'),
    'warrior-cut-training-shorts': chart('IN', SHORTS_SIZES, SHORTS_ROWS, 'ASPYR shorts measurements.')
  };

  function chart(unit, sizes, rows, note) {
    return { unit: unit, sizes: sizes, rows: rows, note: note };
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function parseMeasurement(value) {
    if (!value || value === '—') return null;
    var fractions = { '⅛': 0.125, '¼': 0.25, '⅜': 0.375, '½': 0.5, '⅝': 0.625, '¾': 0.75, '⅞': 0.875 };
    var fraction = 0;
    var clean = String(value).trim();
    Object.keys(fractions).forEach(function (character) {
      if (clean.indexOf(character) !== -1) {
        fraction = fractions[character];
        clean = clean.replace(character, '');
      }
    });
    var whole = clean === '' ? 0 : parseFloat(clean);
    return isNaN(whole) ? null : whole + fraction;
  }

  function formatInches(value) {
    var rounded = Math.round(value * 8) / 8;
    var whole = Math.floor(rounded);
    var eighths = Math.round((rounded - whole) * 8);
    var fraction = { 1: '⅛', 2: '¼', 3: '⅜', 4: '½', 5: '⅝', 6: '¾', 7: '⅞' }[eighths] || '';
    if (eighths === 8) return String(whole + 1);
    return (whole === 0 && fraction ? '' : String(whole)) + fraction;
  }

  function displayMeasurement(value, sourceUnit, displayUnit) {
    if (value === '—') return value;
    if (sourceUnit === displayUnit) return value;
    var numeric = parseMeasurement(value);
    if (numeric === null) return value;
    if (displayUnit === 'CM') {
      var centimeters = Math.round(numeric * 2.54 * 10) / 10;
      return String(centimeters).replace(/\.0$/, '');
    }
    return formatInches(numeric / 2.54);
  }

  function selectedSize(modal) {
    var section = modal.closest('[data-section-type="product"]') || document;
    var selected = section.querySelector('.variant-input-wrap[data-handle="size"] input:checked');
    return selected ? String(selected.value).trim().toUpperCase() : '';
  }

  function renderGuide(modal, unit) {
    var data = CHARTS[modal.dataset.chartKey];
    var holder = modal.querySelector('[data-aspyr-size-guide-table]');
    if (!data || !holder) return;
    var currentSize = selectedSize(modal);
    var html = '<table class="aspyr-size-guide__table"><thead><tr><th scope="col">Size</th>';
    data.sizes.forEach(function (size) {
      var active = currentSize === String(size).toUpperCase() ? ' class="is-selected"' : '';
      html += '<th scope="col"' + active + '>' + escapeHtml(size) + '</th>';
    });
    html += '</tr></thead><tbody>';
    data.rows.forEach(function (row) {
      html += '<tr><th scope="row">' + escapeHtml(row[0]) + '</th>';
      row.slice(1).forEach(function (value, index) {
        var active = currentSize === String(data.sizes[index]).toUpperCase() ? ' class="is-selected"' : '';
        html += '<td' + active + '>' + escapeHtml(displayMeasurement(value, data.unit, unit)) + '</td>';
      });
      html += '</tr>';
    });
    html += '</tbody></table>';
    holder.innerHTML = html;
    modal.dataset.activeUnit = unit;
    modal.querySelectorAll('[data-aspyr-size-guide-unit]').forEach(function (button) {
      var active = button.dataset.aspyrSizeGuideUnit === unit;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    var copy = modal.querySelector('[data-aspyr-size-guide-unit-copy]');
    if (copy) copy.textContent = unit === 'IN' ? 'Values shown in inches.' : 'Values shown in centimeters.';
    var note = modal.querySelector('[data-aspyr-size-guide-note]');
    if (note) note.textContent = data.note;
  }

  function hideLegacyGuide(modal) {
    var section = modal.closest('[data-section-type="product"]');
    if (!section) return;
    section.querySelectorAll('.shopify-app-block, .size-chart__standalone').forEach(function (block) {
      if (block.querySelector('[data-aspyr-size-chart-trigger]')) return;
      var content = (block.textContent || '').toLowerCase();
      if (block.classList.contains('size-chart__standalone') || content.indexOf('size chart') !== -1 || block.querySelector('[class*="kiwi" i], [id*="kiwi" i]')) {
        block.hidden = true;
        block.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function openGuide(trigger) {
    var target = trigger.dataset.aspyrSizeGuideTarget;
    var modal = target ? document.getElementById(target) : null;
    if (!modal) return;
    hideLegacyGuide(modal);
    modal._aspyrPreviousFocus = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    renderGuide(modal, modal.dataset.defaultUnit || 'IN');
    document.documentElement.classList.add('aspyr-size-guide-is-open');
    document.body.classList.add('aspyr-size-guide-is-open');
    trigger.setAttribute('aria-expanded', 'true');
    window.requestAnimationFrame(function () {
      modal.classList.add('is-open');
      var close = modal.querySelector('.aspyr-size-guide__close');
      if (close) close.focus();
    });
  }

  function closeGuide(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('aspyr-size-guide-is-open');
    document.body.classList.remove('aspyr-size-guide-is-open');
    var trigger = document.querySelector('[data-aspyr-size-guide-target="' + modal.id + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    window.setTimeout(function () {
      modal.hidden = true;
      if (modal._aspyrPreviousFocus && typeof modal._aspyrPreviousFocus.focus === 'function') {
        modal._aspyrPreviousFocus.focus();
      }
    }, 240);
  }

  function openLegacyGuide(trigger) {
    var section = trigger.closest('[data-section-type="product"]') || document;
    var selectors = [
      '.kiwi-sizing-chart button',
      '.kiwi-sizing-chart [role="button"]',
      '[class*="kiwi-sizing-chart"] button',
      '[class*="kiwi-sizing-chart"] [role="button"]'
    ];
    var legacy = section.querySelector(selectors.join(','));
    if (legacy && legacy !== trigger) legacy.click();
  }

  function initialize(root) {
    (root || document).querySelectorAll('[data-aspyr-size-guide]').forEach(function (modal) {
      if (modal.dataset.aspyrSizeGuideReady === 'true') return;
      modal.dataset.aspyrSizeGuideReady = 'true';
      renderGuide(modal, modal.dataset.defaultUnit || 'IN');
      hideLegacyGuide(modal);
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-aspyr-size-chart-trigger]');
    if (trigger) {
      event.preventDefault();
      openGuide(trigger);
      return;
    }
    var fallback = event.target.closest('[data-aspyr-size-chart-fallback]');
    if (fallback) {
      event.preventDefault();
      openLegacyGuide(fallback);
      return;
    }
    var unit = event.target.closest('[data-aspyr-size-guide-unit]');
    if (unit) {
      var unitModal = unit.closest('[data-aspyr-size-guide]');
      renderGuide(unitModal, unit.dataset.aspyrSizeGuideUnit);
      return;
    }
    var close = event.target.closest('[data-aspyr-size-guide-close]');
    if (close) closeGuide(close.closest('[data-aspyr-size-guide]'));
  });

  document.addEventListener('change', function (event) {
    if (!event.target.closest('.variant-input-wrap[data-handle="size"]')) return;
    document.querySelectorAll('[data-aspyr-size-guide]').forEach(function (modal) {
      renderGuide(modal, modal.dataset.activeUnit || modal.dataset.defaultUnit || 'IN');
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeGuide(document.querySelector('[data-aspyr-size-guide].is-open'));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });

  var legacyObserver = new MutationObserver(function () {
    document.querySelectorAll('[data-aspyr-size-guide]').forEach(hideLegacyGuide);
  });
  legacyObserver.observe(document.documentElement, { childList: true, subtree: true });
}());
